import { ToasterService } from '@abp/ng.theme.shared';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AssetDetailsDto, AssetService } from '@proxy/register-service/assets';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-is-active-modal',
  templateUrl: './is-active-modal.component.html',
  styleUrls: ['./is-active-modal.component.scss'],
})
export class IsActiveModalComponent implements OnInit {
  @Input() openIsActiveModal: boolean;
  @Input() asset: AssetDetailsDto;
  @Input() showMessage = false;
  @Input() assets: string[];
  @Output() modalClose = new EventEmitter<boolean>();

  form: FormGroup;
  isBusy: boolean = false;

  constructor(
    private fb: FormBuilder,
    public readonly assetService: AssetService,
    public readonly toasterService: ToasterService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      isActive: [this.asset?.isActive ?? true],
      isRecalled: [this.asset?.isRecalled ?? false],
    });
  }

  setActive(value: boolean) {
    this.form.patchValue({ isActive: value });
  }

  applyStatusChanges() {
    if (this.form.invalid) return;

    this.isBusy = true;
    const { isActive, isRecalled } = this.form.value;

    this.assetService
      .performAction({
        actionType: 'toggleActive',
        asset: this.asset,
        assetIds: this.assets,
        isActiveSelected: isActive,
      })
      .pipe(
        switchMap(() =>
          this.assetService.performAction({
            actionType: 'toggleRecalled',
            asset: this.asset,
            assetIds: this.assets,
            isRecalledSelected: isRecalled,
          })
        )
      )
      .subscribe({
        next: () => {
          this.isBusy = false;
          this.modalClose.emit(true);
          this.toasterService.success('RegisterService::Successful');
        },
        error: err => {
          this.isBusy = false;
          console.error('Error applying status changes', err);
          this.toasterService.error('RegisterService::Error');
        },
      });
  }
}
